import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classes from "./IntrinsicValue.module.scss";
function IntrinsicValueCalculator() {
  const [eps, setEps] = useState(15);
  const [cmp, setCmp] = useState("");
  const [growthRate, setGrowthRate] = useState(10);
  const [bondYield, setBondYield] = useState(6.7);
  const [intrinsicValue, setIntrinsicValue] = useState("");

  useEffect(() => {
    setIntrinsicValue(eps * (8.5 + 2 * growthRate) * (4.4 / bondYield));
  }, [eps, cmp, growthRate, bondYield]);

  return (
    <div className={classes.IntrinsicValueCalculator}>
      <h1>
        <Link to='/calculators'>Calculator</Link>
      </h1>
      <div>
        <h3>Intrinsic Value Calculator</h3>
        <div>
          <label>Current Market Price </label>
          <input
            type='number'
            id='cmp'
            value={cmp}
            onChange={(e) => setCmp(e.target.value)}
          />
        </div>
        <div>
          <label>Earning Per Share (EPS) </label>
          <input
            type='number'
            id='eps'
            value={eps}
            onChange={(e) => setEps(e.target.value)}
          />
        </div>
        <div>
          <label>Expected Annual Growth Rate </label>
          <input
            type='number'
            id='growth-rate'
            value={growthRate}
            onChange={(e) => setGrowthRate(e.target.value)}
          />
        </div>
        <div>
          <label>Bond Yield </label>
          <input
            type='number'
            id='bond-yield'
            value={bondYield}
            onChange={(e) => setBondYield(e.target.value)}
          />
        </div>

        <p>{`Intrinsic Value = ${(
          eps *
          (8.5 + 2 * growthRate) *
          (4.4 / bondYield)
        ).toFixed(2)}`}</p>

        {cmp !== "" ? (
          <p>
            {cmp >= intrinsicValue ? (
              <span style={{ color: "red" }}>Overvalued</span>
            ) : (
              <span style={{ color: "green" }}>Undervalued</span>
            )}{" "}
            by {(((cmp - intrinsicValue) / intrinsicValue) * 100).toFixed(2)}%
            and {(intrinsicValue - cmp).toFixed(2)} Rs.
          </p>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default IntrinsicValueCalculator;
